import React from 'react';

import { WELCOME_EMAIL_FROM } from '../../../common/welcomeEmailApi.js';
import { PREVIEW_LINK, renderWelcomeEmail } from '../../../common/welcomeEmailTemplate.js';

// The email as one recipient will receive it. The real link only exists once the email is
// sent, so the preview shows a stand-in.
const WelcomeEmailPreview = ({ template, name, email }) => {
    const { subject, body } = renderWelcomeEmail(template, { name, email, link: PREVIEW_LINK });

    return (
        <div className="welcome-email-preview" aria-label="Forhåndsvisning af e-mail">
            <dl className="welcome-email-preview-headers">
                <dt>Fra</dt>
                <dd>{WELCOME_EMAIL_FROM}</dd>
                <dt>Til</dt>
                <dd>{email}</dd>
                <dt>Svar til</dt>
                <dd>{template.reply_to || '–'}</dd>
                <dt>Emne</dt>
                <dd>{subject || '–'}</dd>
            </dl>
            <pre className="welcome-email-preview-body">{body}</pre>
        </div>
    );
};

export default WelcomeEmailPreview;
